module.exports = __webpack_public_path__ + "static/media/analyze.9c6a6820.svg";